module.exports = __webpack_public_path__ + "img/logoCtis.d4a83f80.svg";